const isSlotChangeable = state => state?.trolley.slotChangeable;

export default isSlotChangeable;
